import { getAllClassNames } from "helpers";
import React from "react";
import { UseSortByProps, useSortBy } from "react-instantsearch";
import styles from "./CustomSortBy.module.scss";

interface CustomSortByProps extends UseSortByProps {
    onRefine: (sortBy: string) => void;
}

export const CustomSortBy = (props: CustomSortByProps) => {
    const { options, currentRefinement, refine } = useSortBy(props);
    const { onRefine } = props;
    const [currentSortBy, setCurrentSortBy] = React.useState(currentRefinement);  

   
    return (
      <div className={styles.sortContainer}>
        {options.map((option, index) => (
          <React.Fragment key={option.value}>
            <span
              className={getAllClassNames([
                styles.spanLabel,
                option.value === currentSortBy ? styles.active : undefined,
              ])}
              key={option.value}
              onClick={() => {refine(option.value); onRefine(option.value); setCurrentSortBy(option.value)}}
            >
              {option.label}
            </span>
            {index === options.length - 1 ? null : (
              <span className={styles.divider} />
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };